import { getTenant } from '../../utils'

export default function ShowSignUpLink() {
  console.log('ShowSignUpLink rendered')

  const tenant = getTenant()
  return (
    <center>
      <h1 style={{ paddingTop: '20px'}}>Use the following URL to invite users to request an account:</h1>
      <h1 style={{ paddingTop: '20px'}}>{`${window.location.origin}/${tenant}/signUp`}</h1>
    </center>
  )

}